var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StripBanner',{attrs:{"link":_vm.$store.state.auth.loggedIn ? '/vendo' : '/valuta-casa'}},[(_vm.$store.state.auth.loggedIn)?_c('p',[_vm._v("\n    Vuoi vendere casa? Gratis per te l'Attestato di Prestazione Energetica\n    (APE).\n  ")]):_c('p',[_vm._v("\n    Vuoi valutare il tuo immobile? Per te c'è il Report Valore Casa\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }